"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scaleBetween;

// Scale between AKA normalize
function scaleBetween(value, newMin, newMax, oldMin, oldMax) {
  return (newMax - newMin) * (value - oldMin) / (oldMax - oldMin) + newMin;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-scroll-parallax/cjs/utils/scaleBetween.js
// module id = 837
// module chunks = 2